import { createClient } from '@supabase/supabase-js';
import { publicConfig } from './config';

const config = publicConfig();

export const supabase =
  window.__orivonAppSupabaseClient ||
  (window.__orivonAppSupabaseClient = createClient(
    config.supabaseUrl || 'https://invalid.supabase.co',
    config.supabaseAnonKey || 'invalid-public-key',
    {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: 'orivon-auth'
      }
    }
  ));
